document.addEventListener('DOMContentLoaded', function () {
  const block = document.querySelector('.whatsocial-block');

  if (block) {
    const video = block.querySelector('.whatsocial-block video');

    // Page scroll event handler
    window.addEventListener('scroll', () => {
      const rect = video.getBoundingClientRect();

      // Check that at least part of the video is on the screen
      if (rect.top <= window.innerHeight && rect.bottom >= 0) {
        setTimeout(() => {
          block.classList.add('fade-in-animation')
          video.play();
        }, 1000)
      }
    });
  }
});
